export const API_BASE = import.meta.env.VITE_API_BASE ?? "https://multi-m.uz";

export async function chatREST(sessionId: string, messages: {role:string,content:string}[], temperature=0.7) {
  const r = await fetch(`${API_BASE}/gpt/chat`, {
    method: "POST",
    headers: {"Content-Type":"application/json"},
    body: JSON.stringify({ session_id: sessionId, messages, temperature }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json() as Promise<{session_id:string, content:string}>;
}

export function openWS() {
  // строим ws(s) URL из API_BASE
  const api = new URL(API_BASE);                      // напр. http://localhost:8006
  api.protocol = api.protocol === "https:" ? "wss:" : "ws:";
  // гарантируем корректный путь
  const basePath = api.pathname.replace(/\/+$/, "");  // без хвостового /
  api.pathname = `${basePath}/gpt/chat/ws`;
  return new WebSocket(api.toString());
}
export async function fetchHistory(tgUserId: number, limit = 10) {
  const r = await fetch(`${API_BASE}/gpt/history/${tgUserId}?limit=${limit}`);
  if (!r.ok) throw new Error(await r.text());
  return r.json() as Promise<{ items: { role: string; content: string; created_at: string }[] }>;
}

// ДОБАВЬ в конец файла

export type GalleryItem = {
  id: number;
  image_url?: string | null;
  tg_file_id?: string | null;
  prompt: string;
  is_public: boolean;
  likes: number;
  created_at: string;
};

export async function fetchGallery(
  userId: number,
  page = 1,
  perPage = 24,
  publicOnly = false
): Promise<{ items: GalleryItem[]; total: number; page: number; limit: number }> {
  const r = await fetch(
    `${API_BASE}/gpt/images/user/${userId}?page=${page}&limit=${perPage}&public_only=${publicOnly}`
  );
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}


export async function likeImage(imageId: number, tgUserId?: number) {
  // соберём query только если ID реально есть
  const qs = new URLSearchParams();
  if (tgUserId !== undefined) qs.set("tg_user_id", String(tgUserId));

  const url = `${API_BASE}/gpt/images/${imageId}/like${qs.toString() ? `?${qs}` : ""}`;

  // без JSON-body и без Content-Type -> не будет preflight
  const r = await fetch(url, {
    method: "POST",
    credentials: "include",
  });

  if (!r.ok) throw new Error("Like failed");
  return r.json();
}


export async function togglePublic(id: number, is_public: boolean) {
  const res = await fetch(`${API_BASE}/gpt/images/${id}/visibility`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ is_public }),
    credentials: "include",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);

  // безопасный парсинг
  let data: unknown = null;
  try {
    data = await res.json();
  } catch {
    // на всякий случай, если когда-то вернётся пустой ответ
    return { ok: true, is_public };
  }

  // узкая валидация формы ответа
  const obj = data as { ok?: boolean; is_public?: boolean };
  return {
    ok: obj?.ok === true,
    is_public: typeof obj?.is_public === "boolean" ? obj.is_public : is_public,
  };
}

export type PublicGalleryItem = GalleryItem & {
  owner_id: number;
  owner_name?: string | null;
  owner_username?: string | null;
};

export async function fetchPublicGallery(
  page = 1,
  perPage = 24,
  order: "new" | "top" = "new",
  q = ""
): Promise<{ items: PublicGalleryItem[]; total: number; page: number; limit: number }> {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(perPage),
    order,
  });
  if (q) params.set("q", q);
  const r = await fetch(`${API_BASE}/gpt/images/public?${params.toString()}`);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export function buildShareUrl(imageId: number | string) {
  // хэш-роутер => ссылка должна содержать "#/p/:id"
  const { origin, pathname } = window.location;
  return `${origin}${pathname}#/p/${imageId}`;
}

export async function generateImage(
  tgUserId: number,
  prompt: string
): Promise<GalleryItem> {
  const r = await fetch(`${API_BASE}/gpt/images/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tg_user_id: tgUserId, prompt }),
  });

  if (!r.ok) {
    throw new Error(await r.text());
  }

  const data = await r.json() as { item: GalleryItem };
  return data.item;
}

// ---- Subscriptions ----
export async function createStarsInvoice(planCode: string, userId: number) {
  const r = await fetch(`${API_BASE}/gpt/subscriptions/invoice`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ plan_code: planCode, user_id: userId }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json() as Promise<{ invoice_url: string }>;
}
